"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tryToRetrieveTokens;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actionType = require("../../actionType");

var _actions = require("../../actions");

var Consts = _interopRequireWildcard(require("../../constants"));

var _config = _interopRequireDefault(require("../config"));

var _storageHandlers = require("./storageHandlers");

var _utilities = require("./utilities");

var _marked =
/*#__PURE__*/
_regenerator.default.mark(tryToRetrieveTokens);

function tryToRetrieveTokens() {
  var _ref, tokens;

  return _regenerator.default.wrap(function tryToRetrieveTokens$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(_config.default.options.tokens.persistence === Consts.tokens.persistence.NONE)) {
            _context.next = 4;
            break;
          }

          _context.next = 3;
          return (0, _storageHandlers.clearTokens)();

        case 3:
          return _context.abrupt("return");

        case 4:
          _context.next = 6;
          return (0, _effects.race)({
            tokens: (0, _storageHandlers.retrieveTokens)(),
            loginSuccess: (0, _effects.take)(_actionType.AUTH_LOGIN_SUCCESS)
          });

        case 6:
          _ref = _context.sent;
          tokens = _ref.tokens;

          if (tokens) {
            _context.next = 10;
            break;
          }

          return _context.abrupt("return");

        case 10:
          if (!(0, _utilities.isAnyTokenExpired)(tokens)) {
            _context.next = 15;
            break;
          }

          _context.next = 13;
          return (0, _effects.put)((0, _actions.refreshTokens)(tokens));

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.next = 17;
          return (0, _effects.put)((0, _actions.setTokens)(tokens));

        case 17:
          _context.next = 19;
          return (0, _effects.put)((0, _actions.fetchAuthUserRequest)());

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}